'use client'

export default function ErrorPage() {
  return <div>Error</div>
}
